/**
 * A TRILHA DE NAVEGAÇÃO ("Oportunidades › Estado do Ceará").
 *
 * Substitui o botão solto "← Oportunidades" das telas de detalhe (19/10). O
 * botão ficava fora do eixo do conteúdo, não dizia onde a pessoa estava, e no
 * celular repetia a seta de voltar que a barra de cima já tem. A trilha diz o
 * caminho inteiro, alinhada ao conteúdo, e cada degrau acima do último é um
 * link.
 *
 * O PRIMEIRO DEGRAU VOLTA DE VERDADE, e não "vai para": quando a tela foi
 * aberta a partir da lista (`state.daLista`, que o painel e a ficha põem nos
 * links), clicar nele é o voltar do navegador — a lista reaparece com os
 * mesmos filtros, a mesma aba e a mesma posição de rolagem. Sem esse estado
 * (link direto, aba nova), é um link comum para a lista.
 *
 * No celular ela some (CSS): ali a seta de voltar da barra é o gesto, e uma
 * segunda linha de navegação só repetiria.
 */
import { Link, useLocation, useNavigate } from "react-router-dom";
import css from "./Migalhas.module.css";

export interface Migalha {
  rotulo: string;
  /** Sem `para`, é o degrau em que a pessoa está. */
  para?: string;
}

export function Migalhas({ itens }: { itens: Migalha[] }) {
  const navegar = useNavigate();
  const { state } = useLocation();
  const daLista = (state as { daLista?: boolean } | null)?.daLista === true;

  return (
    <nav className={css.migalhas} aria-label="Onde você está">
      <ol>
        {itens.map((m, i) => {
          const ultimo = i === itens.length - 1;
          return (
            <li key={`${i}-${m.rotulo}`} aria-current={ultimo ? "page" : undefined}>
              {m.para && !ultimo ? (
                <Link
                  to={m.para}
                  onClick={(e) => {
                    if (i === 0 && daLista) {
                      e.preventDefault();
                      navegar(-1);
                    }
                  }}
                >
                  {m.rotulo}
                </Link>
              ) : (
                <span>{m.rotulo}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
